(function () {
  'use strict';

  angular
    .module('relatorios.videoLibrary.solicitacaoVideos', [
      'ui.router',
      'FactoryVfiltroModule',
      'ServiceVfiltroModule',
      'ConstantVfiltroModule',
      'ProntuarioLinkModule',
      'angularMoment',
      'v3gAuthenticatorModule',
      'pascalprecht.translate'
    ]);
}());
